import { Popover, Row, Tag } from 'antd'
import { useState } from 'react'

import { Icon } from '@iconify/react'

import '../../tasks.index.css'

const PrioritySelector = ({
    value,
    onChange,
    name,
    priorityType,
    updateDetails,
    disabled = false,
}) => {
    const [visible, setVisible] = useState(false)

    const handleSelect = (val) => {
        if (disabled) return
        onChange?.(val)
        updateDetails(name, val)
        setVisible(false)
    }

    const content = (
        <div className="flex flex-col gap-1 w-[160px]">
            {priorityType?.length > 0 &&
                priorityType.map((item) => {
                    const isSelected = item?.value === value

                    const isAnySelected = priorityType?.some(
                        (item) => item?.value === value
                    )

                    return (
                        <Row
                            key={item.value}
                            onClick={() => handleSelect(item.value)}
                            align="middle"
                            justify="space-between"
                            className={`${isSelected ? '#f7f5ff' : 'hover-bg'}`}
                            style={{
                                columnGap: '2px',
                                backgroundColor: isSelected ? '#f7f5ff' : '',
                                cursor: 'pointer',
                                padding: '8px 20px',
                            }}
                        >
                            <Row
                                className="flex items-center gap-2"
                                align="middle"
                                style={{
                                    columnGap: '2px',
                                }}
                            >
                                {isAnySelected && (
                                    <div style={{ width: 18 }}>
                                        {isSelected && (
                                            <Icon
                                                icon="ic:round-check"
                                                height={18}
                                                width={18}
                                                className="svgColor"
                                            />
                                        )}
                                    </div>
                                )}
                                <Tag
                                    color={item?.color}
                                    style={{
                                        borderRadius: '5px',
                                        fontWeight: 500,
                                        padding: '2px 10px',
                                        margin: 0,
                                        fontSize: '13px',
                                    }}
                                >
                                    {item?.label}
                                </Tag>
                            </Row>
                        </Row>
                    )
                })}
        </div>
    )

    const selectedLabel =
        priorityType.find((p) => p.value === value)?.label || 'Select Priority'

    return (
        <Popover
            content={content}
            trigger={disabled ? [] : 'click'}
            placement="bottomLeft"
            open={disabled ? false : visible}
            onOpenChange={(open) => {
                if (!disabled) {
                    setVisible(open)
                }
            }}
            arrow={false}
            overlayInnerStyle={{
                padding: 0,
            }}
            overlayStyle={{
                minWidth: '230px',
                width: '230px',
            }}
            getPopupContainer={(trigger) => trigger.parentNode}
            disabled={disabled}
        >
            <Tag
                color={priorityType.find((p) => p?.value === value)?.color}
                style={{
                    borderRadius: '5px',
                    fontWeight: 500,
                    padding: '2px 10px',
                    margin: 0,
                    cursor: disabled ? 'default' : 'pointer',
                }}
            >
                {selectedLabel}
            </Tag>
        </Popover>
    )
}

export default PrioritySelector
